export default {
  title: 'Notifications',
  subtitle:
    'Choose what you receive from the {organization} organization. Your choices apply to it alone, and win over its defaults.',
  loadFailed: 'Your notifications could not be loaded.',
  empty: {
    title: 'No notifications for you here',
    description:
      "Nothing the organization sends concerns you yet: you need to be able to open a workspace, to moderate one, to review registration requests, or to manage a channel's sales.",
  },
  mandatory: 'Required',
  mandatoryHint: 'This notification is owed to you: its email cannot be turned off.',
  everywhere: {
    workspace: 'In every workspace you can open',
    website: 'On every channel whose sales you manage',
  },
  reset: 'Back to default',
  kinds: {
    uploadReceived: {
      label: 'New files',
      description: 'When a video or another file is added to a workspace you can open.',
    },
    uploadPendingModeration: {
      label: 'Files to review',
      description: 'When a file added to a moderated workspace is waiting for approval before its members can see it.',
    },
    membershipRequestReceived: {
      label: 'New registration requests',
      description: 'When someone asks to join the organization through its public form.',
    },
    membershipRequestsWaiting: {
      label: 'Waiting registration requests',
      description: 'A reminder at most once a week, while requests have waited seven days for an answer.',
    },
    saleReceived: {
      label: 'New sales',
      description:
        'When one of your channels sells an access, a rental or a subscription: one message per sale, never for a renewal.',
    },
    contactMessageReceived: {
      label: 'New messages',
      description:
        "When a visitor writes to one of your channels through its contact form. By email, the form already sends each message to the channel's contact address.",
      everywhere: 'On every channel whose messages you read',
      websitesEmpty: "You haven't made a choice for any channel in particular.",
    },
    depositReceived: {
      label: 'New deposits',
      description:
        "When a member deposits a file in one of your channels' inbox. By email only if you turn it on.",
      everywhere: 'On every channel whose deposits you handle',
      websitesEmpty: "You haven't made a choice for any channel in particular.",
    },
  },
  unknownKind: 'A notification this version of the application cannot describe yet.',
  channels: {
    email: 'Email',
    inApp: 'In the app',
  },
  sources: {
    memberScoped: 'Your choice for this workspace',
    member: 'Your choice',
    organization: 'Organization default',
    registry: 'Default',
    none: 'Off',
  },
  sourceHints: {
    memberScoped: 'You chose it for this workspace: it wins over your choice for the whole organization.',
    member: 'You chose it for the whole organization.',
    organization: 'Set by the organization for the people this notification is meant for.',
    registry: "The platform's default.",
    none: 'You only receive it if you turn it on.',
  },
  workspaces: {
    title: 'Followed workspaces',
    empty: "You don't follow any workspace in particular. To follow one, open it and click the bell next to its name.",
    followed: 'Followed',
    excluded: 'Excluded',
    unfollow: 'Unfollow',
    removeException: 'Remove the exception',
  },
  websites: {
    title: 'Per-channel settings',
    empty:
      "You haven't made a choice for any channel in particular. A channel's setting is in its monetization settings: “Notify me of each sale”.",
    enabled: 'On',
    disabled: 'Off on this channel',
    clear: 'Remove this choice',
  },
  refusals: {
    mandatory: 'This notification is required by email.',
    notEligible: 'This notification no longer concerns you.',
    notSelectable: 'This channel is not available yet.',
    failed: 'The change could not be saved.',
  },
}
